import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { RootState } from '../../shared/state/root-reducer';
import { setChannelFromCode, ChannelCode } from '../state/payment-context-slice';


// If on /mobile route: always set to 'mobile'
// If URL has valid ?ch= param: always update Redux to match
// If no ?ch= param: keep existing Redux value, or default to 'fms' if null

export function useHubChannel() {
  const dispatch = useDispatch();
  const location = useLocation();
  const currentChannelId = useSelector((state: RootState) => state.paymentContext?.channelId);
  
  const isMobileRoute = location.pathname.startsWith('/mobile');
  
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const channelCode = searchParams.get('ch') as ChannelCode | null;
    const validChannelCodes: ChannelCode[] = ['web', 'vt', 'crm', 'mobile', 'fms'];
    const isValidChannel = channelCode && validChannelCodes.includes(channelCode);
    
    if (isMobileRoute) {
      dispatch(setChannelFromCode('mobile'));
    } else if (isValidChannel) {
      dispatch(setChannelFromCode(channelCode));
    } else if (currentChannelId === null) {
      dispatch(setChannelFromCode('fms'));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  return { currentChannelId, isMobileRoute };
}
